var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 41,
    rx: 5.5,
    fill: "white",
    stroke: "#ECEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.533 32.0946H21.04C22.9763 32.0946 25.215 30.337 25.215 28.0517V9.99997H19.8903C17.4094 9.99997 15.533 11.5231 15.533 14.1602V32.0946Z",
    fill: "#2F93FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4265 32.0946H31.9335C33.8698 32.0946 36.1092 30.337 36.1092 28.0517V9.99997H30.7838C28.3022 9.99997 26.4265 11.5231 26.4265 14.1602V32.0946Z",
    fill: "#EC3B56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4714 32.0946H42.9783C44.9146 32.0946 47.1541 30.337 47.1541 28.0517V9.99997H41.829C39.3481 9.99997 37.4717 11.5231 37.4717 14.1602L37.4714 32.0946Z",
    fill: "#4DCC71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5124 21.6876H14C14.424 23.3284 16.4203 24.6181 18.6597 24.6181C20.7172 24.6181 23.5009 23.5042 23.5009 21.3947V17.5861H20.0515V21.3948C20.0515 22.5087 19.1436 23.3875 17.8726 23.3875C16.7234 23.3872 15.6942 22.6841 15.5124 21.6876Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.703 22.4496C45.703 23.3281 44.917 24.0315 43.8879 24.0315H36.2635V17.5856H43.8879C44.795 17.5856 45.5828 18.3477 45.5828 19.2269C45.5828 20.1053 44.7954 20.8677 43.8879 20.8677C44.917 20.8675 45.703 21.5708 45.703 22.4496ZM39.1676 20.516H41.528C42.1332 20.516 42.6777 19.9887 42.6777 19.4021C42.6777 18.8168 42.1332 18.2888 41.528 18.2888H39.1676V20.516ZM41.5885 23.3282C42.193 23.3282 42.7383 22.8009 42.7383 22.2149C42.7383 21.6288 42.1931 21.1016 41.5885 21.1016H39.1676V23.3278H41.5885V23.3282Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4403 22.9181V24.0314H28.6306C26.8155 24.0314 25.3025 22.5665 25.3025 20.8087C25.3025 19.0514 26.8155 17.586 28.6306 17.586H34.4403V18.7583C33.0485 18.4652 31.7163 18.2894 31.0509 18.2894C29.5992 18.2894 28.4495 19.4027 28.4495 20.809C28.4495 22.2154 29.5992 23.3287 31.0509 23.3287C31.7163 23.328 33.0485 23.2112 34.4403 22.9181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.bbf7d1a43a4d9719bdda62b995fb9cb4.svg";
export { ForwardRef as ReactComponent };